import { createSignal } from 'solid-js';

// UCH-427: celebration overlay state. Module-level signals like theme.store —
// client-only UI state, no persistence. Used by the first-login Welcome and by
// publish flows; `forced` is what separates the two (it drives the Welcome
// banner on /profile, which a publish celebration must not show).

const [playId, setPlayId] = createSignal(0);
const [forced, setForced] = createSignal(false);

// The first-entry celebration fires once per app session, no matter how many
// times the session query refetches while welcomed_at is still null.
let autoPlayed = false;

/** 0 = idle; each increment (re)plays the celebration overlay. */
export const welcomePlayId = playId;

/** Debug mode (Ctrl+Alt+W): the Welcome banner shows even without mustSetName. */
export const welcomeForced = forced;

export const celebrate = (opts?: { forced?: boolean }): void => {
  if (opts?.forced) setForced(true);
  setPlayId((n) => n + 1);
};

/** Returns true only on the play that actually fired this session. */
export const autoPlayWelcomeOnce = (): boolean => {
  if (autoPlayed) return false;
  autoPlayed = true;
  celebrate();
  return true;
};

export const endWelcome = (): void => {
  setForced(false);
  setPlayId(0);
};
